<template>
    <div class='gift-code-redeem'>
        <el-card class='box-card'>
            <div slot='header' class='clearfix'>
                <h3 style='display: inline-block'><span
                    v-if='redeemProjectName && projectList && getGameName'>{{ getGameName }} </span>{{ $t('giftCode.title') || '礼包码兑换'
                    }}</h3>
            </div>
            <el-form :model='form' :rules='rules' ref='redeemForm' label-position='top' class='redeem-form'>
                <el-form-item :label="$t('giftCode.selectProject') || '选择游戏'" prop='projectName'>
                    <el-select
                        v-model='form.projectName'
                        size='mini'
                        filterable
                        :placeholder="$t('giftCode.selectProjectPlaceholder') || '请选择游戏'"
                        :loading='projectLoading'
                    >
                        <el-option
                            v-for='item in projectList'
                            :key='item.name'
                            :label='isEnglish ? item.name : item.cnName'
                            :value='item.name'
                        >
                            <div class='project-option'>
                                <img :src='item.icon' class='project-icon' alt='' />
                                <span class='project-name'>{{ isEnglish ? item.name : item.cnName }}</span>
                            </div>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('giftCode.code') || '礼包码'" prop='code'>
                    <el-input
                        v-model='form.code'
                        size='mini'
                        :placeholder="$t('giftCode.enterCode') || '请输入礼包码'"
                        clearable
                    />
                </el-form-item>
                <el-form-item prop='code'>
                    <el-button
                        type='primary'
                        size='mini'
                        :loading='redeemLoading'
                        @click='handleRedeem'
                    >
                        {{ $t('giftCode.redeem') || '兑换' }}
                    </el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { projectApi } from '@/service/api/projectApi';
import { localStg } from '@/utils/storage/local';

export default defineComponent({
    name: 'GiftCodeRedeem',
    data() {
        return {
            form: {
                projectName: '',
                code: ''
            },
            projectList: [],
            projectLoading: false,
            redeemLoading: false,
            rules: {
                projectName: [
                    {
                        required: true,
                        message: this.$t('giftCode.selectProjectRequired') || '请选择游戏',
                        trigger: 'change'
                    }
                ],
                code: [
                    {
                        required: true,
                        message: this.$t('giftCode.enterCodeRequired') || '请输入礼包码',
                        trigger: 'blur'
                    }
                ]
            },
            redeemProjectName: undefined
        };
    },
    created() {
        this.fetchProjectList();
        
        const projectName = this.$route.query.projectName;
        if (projectName) {
            this.form.projectName = projectName;
            this.redeemProjectName = projectName;
        }
        
        const timer = setInterval(() => {
            if (this.form.projectName) {
                clearInterval(timer);
                return;
            }
            
            const projectName = this.$route.query.projectName;
            if (projectName) {
                this.form.projectName = projectName;
                this.redeemProjectName = projectName;
                clearInterval(timer);
            }
        }, 500);
    },
    computed: {
        isEnglish() {
            return localStg.get('app_locale') && localStg.get('app_locale').startsWith('en');
        },
        getGameName() {
            if (!this.projectList || !this.projectList.length || !this.redeemProjectName) {
                return undefined;
            }
            
            for (let i = 0; i < this.projectList.length; i++) {
                const project = this.projectList[i];
                if (project.name === this.redeemProjectName) {
                    if (this.isEnglish) {
                        return project.name;
                    }
                    return project.cnName;
                }
            }
            return undefined;
        }
    },
    methods: {
        async fetchProjectList() {
            this.projectLoading = true;
            try {
                const result = await projectApi.queryAllProject();
                if (result.code === 200 && result.data) {
                    this.projectList = result.data;
                }
            } catch (error) {
                console.error('Failed to fetch project list:', error);
            } finally {
                this.projectLoading = false;
            }
        },
        handleRedeem() {
            this.$refs.redeemForm.validate(async (valid) => {
                if (!valid) {
                    return false;
                }
                this.redeemLoading = true;
                try {
                    const result = await projectApi.codeRedeem(this.form.code, this.form.projectName);
                    if (result.code === 200) {
                        this.$alert(
                            this.$t('giftCode.redeemSuccessTip') || '兑换成功！请关闭游戏并重新进入，奖励将自动发放到您的账户中。',
                            this.$t('giftCode.redeemSuccessTitle') || '兑换成功',
                            {
                                confirmButtonText: this.$t('common.confirm') || '确定',
                                type: 'success'
                            }
                        );
                    }
                } catch (error) {
                
                } finally {
                    this.redeemLoading = false;
                }
            });
        }
    }
});
</script>

<style scoped>
.gift-code-redeem {
    padding: 0;
}

.redeem-form {
    max-width: 500px;
}

.project-option {
    display: flex;
    align-items: center;
}

.project-icon {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    margin-right: 10px;
    object-fit: cover;
}

.project-name {
    flex: 1;
}
</style>
